import { render, staticRenderFns } from "./TitleLinkColumns.vue?vue&type=template&id=2bdf3e4a&"
import script from "./TitleLinkColumns.ts?vue&type=script&lang=ts&"
export * from "./TitleLinkColumns.ts?vue&type=script&lang=ts&"
import style0 from "./TitleLinkColumns.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports